import { Sens, TiersFullLibelle } from '@mairistem/comptabilite';

const getLibelleTiersBySens = (
  sens: string,
) => (sens === Sens.DEPENSE ? TiersFullLibelle.FOURNISSEUR : TiersFullLibelle.DEBITEUR);

export default getLibelleTiersBySens;
